import React, {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom';
import {dataColumn} from '../../../../components/DataColumn';
import CommonGrid from '../../../../components/DataGrid/CommonGrid';
import {useGetWFAQuery} from "../../../../store/api/bidComparsion";
import Table from "../../../../helpers/table";
import {emergencies} from "../../../../constDatas/constDatas";
import moment from "moment";
import {Box, IconButton} from "@mui/material";
import {Folder} from "@mui/icons-material";
import {Icon} from "@iconify/react/dist/iconify";

const Drafts = ({watch, handleUpdateData, handleRowAttachment}) => {
    const navigate = useNavigate()
    const {data, isLoading, refetch} = useGetWFAQuery(watch())
    const dynamicKey = 'rfqMainId'
    const draftData = data?.data?.map(item => {
        return {
            ...item,
            comparisondeadline: item?.comparisondeadline && moment(item?.comparisondeadline).format('DD.MM.YYYY'),
            rfqDeadline: item?.rfqDeadline && moment(item?.rfqDeadline).format('DD.MM.YYYY HH:mm'),
            comparisonDate: item?.comparisonDate && moment(item?.comparisonDate).format('DD.MM.YYYY'),
        }
    })

    // Columns
    const columns = (handleNavigation, handleRowDelete, handleRowApprove, handleRowHold, handleRowReject) => [
        {
            field: 'actions',
            headerName: 'Actions',
            headerAlign: 'center',
            align: 'center',
            renderCell: params => {
                return <>
                    {params.row.hasAttachments ? (
                        <IconButton
                            sx={{p: 0}}
                            onClick={() => {
                                handleRowAttachment(params.row.bidComparisonId)
                            }}
                        >
                            <Icon icon="iconoir:attachment" color="green"/>
                        </IconButton>
                    ) : (
                        <IconButton sx={{p: 0}}>
                            <Icon icon="iconoir:attachment"/>
                        </IconButton>
                    )}
                </>
            }
        },
        dataColumn('rowNum', 'Line no', 70, "number"),
        dataColumn('rfqMainId', "RFQ Main Id", 100,),
        dataColumn('bidComparisonId', "BID Comparison Id", 120,),
        dataColumn('emergency', 'Emergency', 150, '', false, (params) => {
            const emergency = emergencies.find(data => data.value === params.row?.emergency)
            return <Box display="flex" justifyContent="space-around" alignItems="center" gap={1}>
                <Box sx={{minWidth: '40px'}}>{emergency.label}</Box>
                {emergency.icon}
            </Box>
        }), dataColumn('singleSourceReasons', 'Single Source Reasons', 150),
        dataColumn('comparisonNo', 'Comparison Number', 150),
        dataColumn('revision', 'Revision', 150),
        dataColumn('rfqNo', 'RFQ Number', 150, '', false, (params) => {
            return <Box>
                {params.row?.rfqNo}
                <IconButton
                    onClick={() => {
                        navigate(`/rfqs/${params.row?.rfqMainId}`)
                    }
                    }

                >
                    <Folder style={{color: '#3498db', width: '25px', height: '25px'}}/>
                </IconButton>
            </Box>
        }),
        dataColumn('cheapestVendorAndPrice', 'Cheapest Vendor And Price', 150),
        dataColumn('createdBy', 'Created By', 150),
        dataColumn('buyer', 'Buyer', 150),
        dataColumn('comparisonDate', 'Comparison Date', 120),
        dataColumn('comparisondeadline', 'Deadline', 120),
        dataColumn('rfqDeadline', 'RFQ Deadline', 120),
        dataColumn('specialistComment', 'Procurement Comment', 150),
    ];

    const [visibleColumns, setVisibleColumns] = useState(Table.generateVisibleFields(columns(), 'bidComparsionWFA', {rfqMainId: false}))

    useEffect(() => {
        localStorage.setItem('bidComparsionWFA', JSON.stringify(visibleColumns));
    }, [visibleColumns]);

    return (
        <div>
            <CommonGrid handleUpdateData={handleUpdateData} isLoading={isLoading} handleReset={() => refetch()}
                        columnVisibility={visibleColumns}
                        setColumnVisibility={setVisibleColumns}
                        columns={columns}
                        data={{data: draftData}} dynamicKey={dynamicKey} height={430}/>
        </div>
    )
}

export default Drafts
